import { transformDateValue } from 'core/js/FormUtils';
export const getMlmuserView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let mlmuserList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"userid","fieldValue":transformDataValue(data.userid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"User Type","fieldValue":transformDataValue(data.usertype,"string"), "fieldType":"string"},
                            {"fieldLabel":"MLM User Type Id","fieldValue":transformDataValue(data.mlmusertypeid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"MLM User Type Name","fieldValue":transformDataValue(data.mlmusertypename,"string"), "fieldType":"string"},
                            {"fieldLabel":"Senior Partner Id","fieldValue":transformDataValue(data.seniorpartnerid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Mobile Number","fieldValue":transformDataValue(data.mobilenumber,"mobile"), "fieldType":"mobile"},
                            {"fieldLabel":"Login Status","fieldValue":transformDataValue(data.loginstatus,"number"), "fieldType":"number"},
                            {"fieldLabel":"Member Count","fieldValue":transformDataValue(data.membercount,"number"), "fieldType":"number"},
                            {"fieldLabel":"pkgId","fieldValue":transformDataValue(data.pkgid,"number"), "fieldType":"number"},
                            {"fieldLabel":"paymentId","fieldValue":transformDataValue(data.paymentid,"string"), "fieldType":"string"},
                            {"fieldLabel":"paymentAmount","fieldValue":transformDataValue(data.paymentamount,"string"), "fieldType":"string"},
                            {"fieldLabel":"couponCode","fieldValue":transformDataValue(data.couponcode,"string"), "fieldType":"string"},
                            {"fieldLabel":"paymentOrderId","fieldValue":transformDataValue(data.paymentorderid,"string"), "fieldType":"string"},
                            {"fieldLabel":"partnershipStatus","fieldValue":transformDataValue(data.partnershipstatus,"string"), "fieldType":"string"},
                            {"fieldLabel":"Aadhar Number","fieldValue":transformDataValue(data.aadharnumber,"string"), "fieldType":"string"},
                            {"fieldLabel":"Kit Delivered","fieldValue":transformDataValue(data.kitdelivered,"boolean"), "fieldType":"boolean"},
                            {"fieldLabel":"Income Range Id","fieldValue":transformDataValue(data.incomerangeid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Payment Status","fieldValue":transformDataValue(data.paymentstatus,"string"), "fieldType":"string"},
                            {"fieldLabel":"Raz Contact Id","fieldValue":transformDataValue(data.razcontactid,"string"), "fieldType":"string"},
                            {"fieldLabel":"Raz Fund Account Id","fieldValue":transformDataValue(data.razfundaccountid,"string"), "fieldType":"string"},
                            {"fieldLabel":"Fund Account Validated","fieldValue":transformDataValue(data.fundaccountvalidated,"boolean"), "fieldType":"boolean"},
                            {"fieldLabel":"Invite Sent On","fieldValue":transformDataValue(data.invitesenton,"date"), "fieldType":"date"},
              
              
            ],
            'dataList': [
                
              ]
          }

          mlmuserList.push(card);
  })
  return mlmuserList;
}